import z from "zod";

export const SimpleResponseSchema = z.object({
  message: z.string().nullable(),
  success: z.boolean(),
});

export type SimpleResponse = z.infer<typeof SimpleResponseSchema>;
